import React from 'react';
import { Form, Divider } from 'semantic-ui-react'

const HomeProg1 = ({autorizacUA, styles, handleChange, handleSubmit, args,
                    handleClickSel11, handleClickSel12, handleClickSel13, handleClickSel14, 
                    handleClickSel15, handleClickSel16, handleClickSel17, 
                    handleClickSel18, handleClickSel19, handleClickSel20, handleClickSel21,
                    handleClickSel22, handleClickSel23, handleClickSel24, handleClickSel25, handleClickSel26}) => {
  const a1502 = autorizacUA.findIndex( autorizac => autorizac === "1502" );
  const a1503 = autorizacUA.findIndex( autorizac => autorizac === "1503" );
  const a1505 = autorizacUA.findIndex( autorizac => autorizac === "1505" );
  const a1510 = autorizacUA.findIndex( autorizac => autorizac === "1510" );
  const a1515 = autorizacUA.findIndex( autorizac => autorizac === "1515" );
  const a1520 = autorizacUA.findIndex( autorizac => autorizac === "1520" );

  if(args.numDocum){
    var numDocum = document.getElementById("numDocum");
    if(numDocum){numDocum.value = args.numDocum}
  }

  if(args.descrPlanta){
    var descrPlanta = document.getElementById("descrPlantaB");
    if(descrPlanta){descrPlanta.value = args.descrPlanta}
  }
  if(args.descrSeccion){
    var descrSeccion = document.getElementById("descrSeccionB");
    if(descrSeccion){descrSeccion.value = args.descrSeccion}
  }
  if(args.descrEquipo){
    var descrEquipo = document.getElementById("descrEquipoB");
    if(descrEquipo){descrEquipo.value = args.descrEquipo}
  }
  if(args.descrComponente){
    var descrComponente = document.getElementById("descrComponenteB");
    if(descrComponente){descrComponente.value = args.descrComponente}
  }
  if(args.descrMecanismo){
    var descrMecanismo = document.getElementById("descrMecanismoB");
    if(descrMecanismo){descrMecanismo.value = args.descrMecanismo}
  }
  if(args.estado){
    var estado = document.getElementById("estado");
    if(estado){estado.value = args.estado}
  }
  return (
    <div>
      <Form onSubmit={()=>handleSubmit(args)}>
        <div>
          <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
            <i className="large search yellow icon"></i>
            Buscar
          </button>

          <div className="ui input fluid">
            <input id='numDocum' name="numDocum" type="number" placeholder="Traer x mecanismos" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrPlanta' autoComplete="off" name="descrPlantaB" type="text" placeholder="Planta" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrSeccion' autoComplete="off" name="descrSeccionB" type="text" placeholder="Sección" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrEquipo' autoComplete="off" name="descrEquipoB" type="text" placeholder="Equipo" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrComponente' autoComplete="off" name="descrComponenteB" type="text" placeholder="Componente" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrMecanismo' autoComplete="off" name="descrMecanismoB" type="text" placeholder="Mecanismo" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='estado' autoComplete="off" name="estado" type="text" placeholder="Estado" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div>
            <Divider inverted />

            <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
              <i className="large list ul yellow icon"></i>
              Opciones
            </button>
          </div>

          {a1502!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel13(ev)}>
              <i className="large angle double down red icon"></i>
              Descargar archivo para edición masiva de tareas
            </button>
          }
          {a1502!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel14(ev)}>
              <i className="large edit outline red icon"></i>
              Edición masiva de tareas
            </button>
          }
          {a1502!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={(ev)=>handleClickSel16(ev)}>
              <i className="large angle double up red icon"></i>
              Adicionar tareas a mecanismos ya creados
            </button>
          }
          {a1505!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel18}>
              <i className="large file excel outline red icon"></i>
              Ver tareas en Excel
            </button>
          }
          {a1505!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel21}>
              <i className="large file excel outline red icon"></i>
              Programación de tareas proyectada
            </button>
          }
          {a1505!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel11}>
              <i className="large calendar plus outline red icon"></i>
              Generar rutas
            </button>
          }
          {a1510!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel12}>
              <i className="large calendar check red icon"></i>
              Reportar y consultar ejecución de rutas
            </button>
          }
          {a1510!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel26}>
              <i className="large calendar check red icon"></i>
              Reportar ejecución de rutas (individual)
            </button>
          }
          {localStorage.getItem('userLogin')==="slcm@slcm.com" &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel25}>
                <i className="large searchengin red icon"></i>
                Reportar ejecución de rutas cerradas
            </button>
          }
          {a1503!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel20}>
              <i className="large calendar check red icon"></i>
              Ordenes de trabajo por hallazgos
            </button>
          }
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel17}>
              <i className="large file excel outline red icon"></i>
              Exportar matríz de órdenes de trabajo ejecutadas 
          </button>
          {a1510!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel19}>
                <i className="large searchengin red icon"></i>
                PDF de Bitacora de órdenes de trabajo
            </button>
          }
          {a1520!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel23}>
                <i className="large searchengin red icon"></i>
                Bitacora diaria de tribología
            </button>
          }
          {/* {a1520!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel24}>
                <i className="large searchengin red icon"></i>
                Bitacora de tareas por turnos
            </button>
          } */}
          {localStorage.getItem('userLogin')==="slcm@slcm.com" &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel22}>
                <i className="large searchengin red icon"></i>
                Descargar archivo para indicadores
            </button>
          }
          {/* {a1515!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel24}>
              <i className="chart bar red icon"></i>
              Tablero de control rutas
            </button>
          } */}
        </div>
      </Form>
    </div>
  )
};

export default HomeProg1